import { Spinner } from '@ps/ui';
import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuthStore } from './store';

/** Keeps a signed-in person off the sign-in screens. */
export function RedirectIfSignedIn({ children }: { children: ReactNode }) {
  const status = useAuthStore((state) => state.status);
  const profileComplete = useAuthStore((state) => state.profileComplete);
  const restore = useAuthStore((state) => state.restore);

  useEffect(() => {
    if (status === 'unknown') void restore();
  }, [status, restore]);

  if (status === 'unknown') {
    return (
      <div className="flex justify-center py-16 text-primary">
        <Spinner size="lg" />
      </div>
    );
  }

  if (status === 'authenticated') {
    return <Navigate to={profileComplete ? '/' : '/register'} replace />;
  }

  return <>{children}</>;
}
